// extracted by mini-css-extract-plugin
export default {"freeBanner":"_2zrnP2tM","trial":"_1h_yj6D-","btn":"o01IXCsz"};